import {
    Box, Flex, useColorModeValue, Image, useDisclosure, IconButton, Stack,
    Collapse, FormControl, Select
} from "@chakra-ui/react"
import { NavLink, useNavigate } from "react-router-dom"
import {
    HamburgerIcon,
    CloseIcon,
} from "@chakra-ui/icons"
import { useDispatch } from "react-redux"
import ColorModeToggle from "./ThemeButton"
import rapidLogo from "../images/rapidToolzLogo.png"
import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next";

export default function NavSignedOut() {

    const { isOpen, onToggle } = useDisclosure()
    const { i18n } = useTranslation()
    const { t } = useTranslation('signedOut')
    const [lang, setLang] = useState(i18n.language)
    const dispatch = useDispatch()
    const navigate = useNavigate()


    // HR - signed-out drawer icons
    const NoUserItems = [
        { name: t('features'), link: "/features" },
        { name: t('pricing'), link: "/pricing" },
        { name: t('free_trial'), link: "/free-trial" },
        { name: t('about_us'), link: "/aboutus" },
        { name: t('contact_us'), link: "/contactus" },
        { name: t('signup_company'), link: "/signup/company" },
        { name: t('signup_user'), link: "/signup/user" },
        { name: t('login'), link: "/login" },
        // { name: t('help'), link: "/help" }
    ]



    // HR - update internal language when redux language value changes 
    useEffect(() => {
        // HR - update internal language on login
        i18n.changeLanguage(lang)
        localStorage.setItem('rapidtoolz_language', lang);
    }, [lang])

    return (
        <Box>
            <Flex
                bg={useColorModeValue("white", "gray.800")}
                color={useColorModeValue("gray.800", "white")}
                minH={"60px"}
                py={{ base: 2 }}
                px={{ base: 4 }}
                borderBottom={1}
                borderStyle={"solid"}
                borderColor={useColorModeValue("gray.200", "gray.900")}
                align={"center"}
            >
                <Flex
                    flex={{ base: 1, md: "auto" }}
                    ml={{ base: -2 }}
                    display={{ base: "flex", lg: "none" }}
                >
                    <IconButton
                        onClick={onToggle}
                        icon={
                            isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
                        }
                        variant={"ghost"}
                        aria-label={"Toggle Navigation"}
                    />
                </Flex>
                <Flex flex={{ base: 1 }} justify={{ base: "center", lg: "start" }}>
                    <NavLink to="/" style={{ marginRight: '1rem' }}>
                        <Image src={rapidLogo} rounded={7.5} objectFit={'fill'} />
                    </NavLink>

                    <Flex display={{ base: "none", lg: "flex" }} ml={10}>
                        <DesktopNav lang={lang} setLang={setLang} NoUserItems={NoUserItems} />
                    </Flex>
                </Flex>

                <Stack
                    flex={{ base: 1, lg: 0 }}
                    justify={"flex-end"}
                    direction={"row"}
                    spacing={2}
                >
                    <ColorModeToggle />
                </Stack>
            </Flex>

            <Collapse in={isOpen} animateOpacity>
                <MobileNav lang={lang} setLang={setLang} NoUserItems={NoUserItems} />
            </Collapse>
        </Box>
    )
}

const DesktopNav = ({ lang, setLang, NoUserItems }) => {

    return (
        <Stack direction={"row"} spacing={2}>
            {NoUserItems.map((navItem, index) => (
                <NavLink key={index} to={navItem.link} >
                    <NavItem>
                        {navItem.name}
                    </NavItem>
                </NavLink>
            ))}
            <FormControl width={'5vw'}>
                <Select value={lang} onChange={(e) => setLang(e.target.value)} variant={"filled"} >
                    <option value='en'>English</option>
                    <option value='es'>Spanish</option>
                    <option value='pt'>Portuguese</option>
                </Select>
            </FormControl>
        </Stack>
    )
}

const MobileNav = ({ lang, setLang, NoUserItems }) => {
    return (
        <Stack
            bg={useColorModeValue("white", "gray.800")}
            p={4}
            display={{ lg: "none" }}
        >
            {NoUserItems.map((navItem, index) => {
                return (
                    <NavLink to={navItem.link} key={index} >
                        <NavItem style={{ margin: "1rem" }} >
                            {navItem.name}
                        </NavItem>
                    </NavLink>
                )
            })}
            <FormControl>
                <Select value={lang} onChange={(e) => setLang(e.target.value)} variant={"filled"} >
                    <option value='en'>English</option>
                    <option value='es'>Spanish</option>
                    <option value='pt'>Portuguese</option>
                </Select>
            </FormControl>
        </Stack>
    )
}

const NavItem = ({ icon, children, ...rest }) => { // each of the sidebar buttons
    return (
        <Box
            style={{ textDecoration: "none" }}
            _focus={{ boxShadow: "none" }}
        >
            <Flex
                align="center"
                mx="4"
                borderRadius="lg"
                role="group"
                cursor="pointer"
                _hover={{
                    color: "cyan.400"
                }}
                {...rest}
            >
                {children}
            </Flex>
        </Box>
    )
}

